export default __webpack_public_path__ + "static/amenagement-balcon-cc5f64abddae4137b6290ffb5f2faa35.png";